import React, { useEffect, useState, useRef, useCallback } from 'react';
import { MaskedInput } from 'antd-mask-input';
import { SearchOutlined } from '@ant-design/icons';
import {
  Row,
  Button,
  Form,
  Col,
  Input,
  message,
  Spin,
  Radio,
  Select,
} from 'antd';

import { TitleSections } from '../../../../components/TitleSections';
import { SelectMultiplo } from '../../../../components/SelectMultiplo';
import userPlus from '../../../../assets/icons/userPlus.svg';
import arrowRigth16 from '../../../../assets/icons/arrowRigth16.svg';
import { formatarCpf } from '../../../../helpers/utils';
import {
  deleteOptionGroup,
  getEditarUsuario,
  listaClientes,
  listaGrupos,
  listaUsuarios,
  putChangeOption,
} from '../../../../services/cadastroUsuario.js';
import api from '../../../../services/api.js';

import * as S from '../styles.js';
import { PoliticasDeSenha } from '../../../../components/PoliticasDeSenha';

export default function UserForm() {
  const [editUser, setEditUser] = useState([{}]);
  const [clientList, setClientList] = useState([{}]);
  const [groupList, setGroupList] = useState([{}]);
  const [form] = Form.useForm();
  const inputRef = useRef(null);
  const [buttonCancel, setButtonCancel] = useState(false);
  const [disableForm, setDisableForm] = useState(true);
  const [listUsers, setListUsers] = useState([]);
  const [inputBusca, setInputBusca] = useState('');
  const [isFromEdit, setIsFromEdit] = useState(false);
  const [userGroup, setUserGroup] = useState([]);
  const [isActive, setIsActive] = useState();
  const [idGroupForNewCustomer, setIdGroupForNewCustomer] = useState('');
  const [loadingReprocessamento, setLoadingReprocessamento] = useState(false);
  const [senha, setSenha] = useState('');
  const styleLocal = {
    input: {
      background: '#F2F2F2',
      border: 'none',
      height: '48px',
    },
    rowTop: {
      width: '100%',
      marginTop: '28px',
      display: 'flex',
    },
    colWithe: {
      background: '#fff',
      borderRadius: '2px',
      height: 'fit-content',
      paddingRight: '5px',
    },
    internCol: {
      borderRadius: '2px',
      height: '680px',
      overflowY: 'auto',
      background: '#fff',
      padding: '90px 22px 16px',
      overflowX: 'hidden',
    },
    internCol2: {
      borderRadius: '2px',
      height: '680px',
      overflowY: 'auto',
      background: '#fff',
      padding: '42px 28px 0 28px',
      overflowX: 'hidden',
    },
    alterButton: {
      cursor: 'pointer',
      fontSize: '14px',
      lineHeight: '16px',
      textAlign: 'center',
      color: '#24A95D',
      fontWeight: 'bold',
      margin: '14px 0',
      textDecoration: 'underline #24A95D',
    },
    formItem: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#707070',
      margin: '10px 0',
    },
    checkStyle: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#707070',
      margin: '0px 0 15px 0',
    },
    formItemButton: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
    },
  };

  const initialData = useCallback(async () => {
    setLoadingReprocessamento(true);
    const registerNumber = '1000';
    const pageNumber = '1';
    const userListData = await listaUsuarios({ registerNumber, pageNumber });
    const clientListData = await listaClientes({ registerNumber, pageNumber });
    const gruopListData = await listaGrupos();
    setClientList(clientListData?.data?.items || []);
    setGroupList(gruopListData?.data || []);
    setListUsers(userListData?.data?.items || []);
    setLoadingReprocessamento(false);
  }, [clientList, groupList, listUsers]);

  const listFiltered = listUsers?.filter(item => {
    if (item.ativo === true) {
      item.ativo = 'ativo';
    } else if (item.ativo === false) {
      item.ativo = 'inativo';
    }
    if (item.nome) {
      const cpfFormatado = item.cpf.replace(
        /^(\d{3})(\d{3})(\d{3})(\d{2})/,
        '$1.$2.$3-$4'
      );
      const concatenado = item.nome
        .concat(item.cpf)
        .concat(item.email)
        .concat(item.ativo)
        .concat(cpfFormatado);
      return concatenado.toLowerCase().includes(inputBusca.toLowerCase());
    }

    return null;
  });
  function ArrowRigth() {
  return <img src={arrowRigth16} alt="arrow" />;
}

  const [activeId, setActiveId] = useState(0);

  function RowsForUsers({ item }) {
    return (
      <S.RowsForColumn active={activeId === item.id}>
        <S.RowData
          key={item.id}
          justify="center"
          onClick={() => handleEditUser(item.id)}
        >
          <S.StyledColRow span={8}>{item.nome}</S.StyledColRow>
          <S.StyledColRow span={8}>
            <MaskedInput
              disabled={true}
              style={{
                textAlign: 'center',
                border: 'none',
                background: 'transparent',
                color: '#707070',
                fontSize: '12px',
              }}
              mask="000.000.000-00"
              value={item.login}
            />
          </S.StyledColRow>
          <S.StyledColRow span={7}>{item.ativo}</S.StyledColRow>
          <S.StyledColRow span={1}>
            <ArrowRigth />
          </S.StyledColRow>
        </S.RowData>
      </S.RowsForColumn>
    );
  }

  function RowUsers() {
    return (
      <Col span={24} style={{ marginTop: '40px' }}>
        {listFiltered?.map((item, i) => <RowsForUsers key={i} item={item} />)}
      </Col>
    );
  }

  const handleEditUser = async id => {
    setEditUser('');
    setUserGroup([]);
    setIsActive();
    setActiveId(id);
    setLoadingReprocessamento(true);
    const response = await getEditarUsuario({ id });
    setDisableForm(false);
    setButtonCancel(true);
    return listUsers.forEach(item => {
      if (item.id === id) {
        if (response.data.length) {
          setUserGroup([...response.data.map(item => item.id)]);
          setIsFromEdit(true);
          setEditUser(item);
          setIsActive(item.ativo === 'ativo' ? 1 : 2);
          return setLoadingReprocessamento(false);
        }
          setIsFromEdit(true);
          const editItem = item;
          setEditUser(editItem);
          return setLoadingReprocessamento(false);
      }
        return null;
    });
  };
  const handleNewUser = async () => {
    setDisableForm(false);
    setIsFromEdit(false);
    setEditUser([{}]);
    setUserGroup([]);
    setIsActive(1);
    setButtonCancel(true);
  };
  const salvarUsuario = useCallback(
    async value => {
      if (value.cpfForm.includes('_')) {
        message.error('CPF inválido');
        return inputRef.current.focus({ cursor: 'start' });
      }
      const { cpfForm, senhaForm, nomeForm, emailForm, clienteForm } = value;
      const cpf = cpfForm || editUser.cpf;
      const senha = senhaForm || editUser.senha;
      const nome = nomeForm || editUser.nome;
      const email = emailForm || editUser.email;
      const ativo = isActive === 1;
      const clientes = clienteForm || editUser.clientes.idClientes;
      const { id } = editUser;
      const cpfFormated = cpf.replaceAll('.', '').replace('-', '');
      const payload = {
        cpf: cpfFormated,
        senha,
        nome,
        email,
        ativo,
        login: cpfFormated,
        idClientes: clientes,
        id,
      };

      setLoadingReprocessamento(true);
      if (isFromEdit) {
        try {
          await api.put('/usuario', payload);
          setUserGroup([]);
          initialData();
          setEditUser([{}]);
          setListUsers([{}]);
          setButtonCancel(false);
          setLoadingReprocessamento(false);
          setDisableForm(true);
          setIsActive();
          message.success(`Cliente ${payload.nome} atualizado com sucesso`);
        } catch (error) {
          message.error('Erro ao editar usuário.');
        }
        return setLoadingReprocessamento(false);
      }
        try {
          const response = await api.post('/usuario', payload);
          const idPost = response.data.id;
          const idGroup = idGroupForNewCustomer[0];
          await api.put(`/Usuario/${idPost}/groups/${idGroup}`);
          setUserGroup([]);
          initialData();
          setEditUser([{}]);
          setListUsers([{}]);
          setIsActive();
          setButtonCancel(false);
          setDisableForm(true);
          message.success('Novo cliente cadastrado com sucesso');
        } catch (error) {
          message.error('Erro ao criar um novo usuário.');
        }
        return setLoadingReprocessamento(false);
    },
    [editUser, isFromEdit, isActive, idGroupForNewCustomer]
  );

  const handleButtonCancel = () => {
    setButtonCancel(false);
    setDisableForm(true);
    setEditUser([{}]);
    setIsActive();
    setUserGroup([]);
    setUserGroup([]);
  };

  const handleChangeOption = async e => {
    setLoadingReprocessamento(true);
    setIdGroupForNewCustomer(e);
    const { id } = editUser;
    const position = e.length;
    const setPosition = e[position - 1];
    await putChangeOption({ id, setPosition });
    return setLoadingReprocessamento(false);
  };

  const handleDeleteOption = async e => {
    const { id } = editUser;
    return await deleteOptionGroup({ id, e });
  };

  const getForm = () => {
    form.setFieldsValue({
      cpfForm: formatarCpf(editUser.cpf),
      senhaForm: editUser.senha,
      nomeForm: editUser.nome,
      emailForm: editUser.email,
      grupoForm: userGroup,
      clienteForm: editUser.clientes?.map(item => item.idCliente),
    });
  };

  function ImgNewUser() {
  return <img src={userPlus} style={{ marginRight: '5px' }} alt="newUser" />;
}

  useEffect(() => {
    setSenha('');
    getForm();
  }, [editUser, userGroup, form]);

  useEffect(() => {
    initialData();
  }, []);

  return (
    <Spin
      spinning={loadingReprocessamento}
      size="large"
      style={{
        width: '100%',
      }}
      tip="Carregando dados de Clientes"
      delay={200}
    >
      <>
        <Row data-testid="topBar" style={{ width: '100%' }}>
          <S.StyledCol span={24}>
            <h2>Usuários</h2>
            <Button
              data-testid="button1"
              style={{
                paddingLeft: '8px',
                height: '45px',
                fontWeight: 'bold',
                width: '150px',
                fontSize: '16px',
              }}
              onClick={() => handleNewUser()}
            >
              <ImgNewUser />
              Novo usuário
            </Button>
          </S.StyledCol>
        </Row>
        <Row justify="center" id="row" style={styleLocal.rowTop}>
          <Col
            span={disableForm ? 24 : 12}
            style={{
              paddingRight: disableForm ? 0 : 24,
            }}
          >
            <Col style={styleLocal.colWithe}>
              <Row
                id="fixe"
                style={{
                  position: 'absolute',
                  width: '100%',
                  background: '#fff',
                  zIndex: '1',
                  padding: '24px 24px 0 24px',
                }}
                span={24}
              >
                <Input
                  placeholder="Busca"
                  onChange={e => setInputBusca(e.target.value)}
                  span={12}
                  style={styleLocal.input}
                  prefix={<SearchOutlined style={{ color: '#24A95D' }} />}
                />
                <Row
                  span={24}
                  style={{
                    position: 'relative',
                    width: '100%',
                    background: '#fff',
                    zIndex: '1',
                    marginTop: '5px',
                  }}
                >
                  <S.RowTitle
                    style={{
                      width: '100%',
                      background: '#fff',
                      borderBottom: '2px solid #CACACA',
                      marginBottom: '3px',
                      color: '#001F2A',
                      fontSize: '12px',
                    }}
                  >
                    <S.StyledColTitle span={8}>Nome</S.StyledColTitle>
                    <S.StyledColTitle span={8}>CPF</S.StyledColTitle>
                    <S.StyledColTitle span={7}>Status</S.StyledColTitle>
                    <S.StyledColTitle span={1} />
                  </S.RowTitle>
                </Row>
              </Row>
              <Col
                justify="center"
                id="col"
                span={24}
                style={styleLocal.internCol}
              >
                <RowUsers />
              </Col>
            </Col>
          </Col>
          <Col span={disableForm ? 0 : 12}>
            <Col style={styleLocal.colWithe}>
              <Col
                justify="center"
                id="col"
                span={24}
                style={styleLocal.internCol2}
              >
                <Row style={{ marginBottom: 22 }}>
                  <TitleSections title="Dados cadastrais do usuário" />
                </Row>
                <Form
                  form={form}
                  onFinish={values => salvarUsuario(values)}
                  layout="vertical"
                  style={{ width: '100%', maxWidth: '100%', minWidth: '0' }}
                >
                  <Form.Item
                    name="nomeForm"
                    label="Nome"
                    rules={[
                      { required: true, message: 'o nome deve ser informado' },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <S.InputStyled
                      size="large"
                      disabled={disableForm}
                      placeholder="Nome"
                    />
                  </Form.Item>
                  <Form.Item
                    name="cpfForm"
                    label="CPF"
                    rules={[
                      { required: true, message: 'o CPF deve ser informado' },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <S.InputStyled
                      disabled={disableForm}
                      size="large"
                      placeholder="CPF"
                    />
                  </Form.Item>
                  <Form.Item
                    name="emailForm"
                    label="E-mail"
                    rules={[
                      {
                        required: true,
                        message: 'o e-mail deve ser informado',
                      },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <S.InputStyled
                      size="large"
                      disabled={disableForm}
                      type="email"
                      placeholder="E-mail"
                    />
                  </Form.Item>
                  <Form.Item
                    name="grupoForm"
                    label="Grupo"
                    rules={[
                      { required: true, message: 'o grupo deve ser informado' },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <SelectMultiplo
                      onDeselect={handleDeleteOption}
                      onChange={handleChangeOption}
                      style={{ cursor: 'pointer' }}
                      showArrow
                      disabled={disableForm}
                      size="large"
                      placeholder="Selecione"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {groupList.map((item, i) => (
                        <Select.Option key={i} value={item.id}>
                          {item.nome}
                        </Select.Option>
                      ))}
                    </SelectMultiplo>
                  </Form.Item>
                  <Form.Item
                    name="clienteForm"
                    label="Cliente"
                    rules={[
                      { required: true, message: 'Selecione um cliente.' },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <SelectMultiplo
                      mode="multiple"
                      style={{ cursor: 'pointer' }}
                      showArrow
                      disabled={disableForm}
                      size="large"
                      placeholder="Selecione"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {clientList?.map((item, i) => (
                          <Select.Option key={i} value={item.id}>
                            {item.nomeFantasia}
                          </Select.Option>
                        ))}
                    </SelectMultiplo>
                  </Form.Item>
                  <Form.Item
                    name="senhaForm"
                    label="Senha"
                    rules={[
                      {
                        required: false,
                        message: 'a senha deve ser informada',
                      },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <S.InputStyled
                      size="large"
                      disabled={disableForm}
                      type="password"
                      placeholder="Senha"
                      onChange={e => setSenha(e.currentTarget.value)}
                    />
                  </Form.Item>
                  {senha && <PoliticasDeSenha senha={senha} />}

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      marginTop: '4%',
                    }}
                  >
                    <Radio.Group
                      style={styleLocal.checkStyle}
                      onChange={e => setIsActive(e.target.value)}
                      value={isActive}
                      disabled={disableForm}
                      defaultValue={isActive}
                    >
                      <Radio value={1}>Ativo</Radio>
                      <Radio value={2}>Inativo</Radio>
                    </Radio.Group>
                    <Form.Item style={styleLocal.formItemButton}>
                      {buttonCancel && (
                        <S.StyledButtonCancel
                          type="primary"
                          htmlType="button"
                          onClick={() => handleButtonCancel()}
                        >
                          Cancelar
                        </S.StyledButtonCancel>
                      )}
                      <S.StyledButton
                        type="primary"
                        htmlType="submit"
                        disabled={disableForm}
                      >
                        Salvar
                      </S.StyledButton>
                    </Form.Item>
                  </div>
                </Form>
              </Col>
            </Col>
          </Col>
        </Row>
      </>
    </Spin>
  );
}
